import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { NpoMerchantOnboardingStateProvider } from '@/contexts/npoMerchantOnboardingContext';
import { i18n } from '@/utils/i18n';

export default function StackLayout() {
  return (
    <NpoMerchantOnboardingStateProvider>
      <PlatformContainer contentCustomClassnames="flex">
        <Stack>
          <Stack.Screen
            name="npoPaymentOnboardingIntro"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.intro')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="index"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.cardTerms')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="achTerms"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.achTerms')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="general"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.completeCompany')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="owner"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.completeOwner')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="riskProfile"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.completeRiskProfile')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="bankAccount"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.completeBankAccount')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
          <Stack.Screen
            name="documents"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('npoPaymentOnboarding.title.completeDocuments')} />,
              headerLeft: () => <GoBackButton />,
              headerStyle: { backgroundColor: 'transparent' }
            }}
          />
        </Stack>
      </PlatformContainer>
    </NpoMerchantOnboardingStateProvider>
  );
}
